export enum TaskLog {
  COMMENT = 'comment',
  ASSIGNEE_CHANGE = 'assignee change',
  STATUS_CHANGE = 'status change',
}
